export enum OrgVisitType {
    PrimaryCare = 1,
    Specialist = 2,
    ED = 3,
}

export const OrgVisitTypeLabels = {
    [OrgVisitType.PrimaryCare]: 'Primary Care',
    [OrgVisitType.Specialist]: 'Specialist',
    [OrgVisitType.ED]: 'ED',
  };